import { makeStyles, Typography, Tooltip } from '@material-ui/core'
import PropTypes from 'prop-types'
import { HelpOutline } from '@material-ui/icons'

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: '5px'
  },
  helpIcon: {
    opacity: '0.5',
    display: 'inline-flex',
    verticalAlign: 'text-top',
    marginLeft: '5px',
    '&:hover': {
      cursor: 'help'
    }
  },
  tooltip: {
    fontSize: '1.3em'
  }
}))

export default function QuestionHeader({ prompt, allowBlanks, helpTooltip }) {
  const classes = useStyles()
  return <Typography variant="h5" className={classes.header}>
    {prompt}
    {prompt && !allowBlanks && <span style={{ color: 'var(--button-color)' }}>*</span>}
    {helpTooltip && <Tooltip placement="top-start" title={<span className={classes.tooltip}>{helpTooltip}</span>} arrow><HelpOutline className={classes.helpIcon} /></Tooltip>}
  </Typography>
}

QuestionHeader.propTypes = {
  prompt: PropTypes.string,
  allowBlanks: PropTypes.bool.isRequired,
  helpTooltip: PropTypes.string
}

